const unitForType = {
    'mbps': ' MBps ',
    'kbps': ' KBps ',
    'cpu': ' % ',
    'iops': ' iops ',
    'latency': ' ms '
};

class DonutService {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }

    getData(metrics, startTime, endTime, interval) {
        return this.$http
            .get('https://nutanix-alpha:9440/PrismGateway/services/rest/v1/cluster/stats/?metrics='+ metrics +'&startTimeInUsecs='+ startTime +'&endTimeInUsecs='+ endTime +'&intervalInSecs='+ interval)
            .then(resp => resp.data);
    }

    getMockData() {
        return this.$q.when([90]);
    }

    formatGraphMouseOver(value, type) {
        return this.formatValue(value,type) + unitForType[type];
    }

    formatValue(value, type) {
        switch (type) {
            case 'mbps':
                return (value/1024).toFixed(1);
            case 'kbps':
                return parseInt(value).toFixed(1);
            case 'cpu':
                return (value/10000).toFixed(1);
            case 'iops':
                return value;
            case 'latency':
                return (value/1000).toFixed(1);
            default:
                return value;
        }
    }
}

DonutService.$inject = ['$http', '$q'];

module.exports = DonutService;



// WEBPACK FOOTER //
// ./src/shared/ctxDonut/ctxDonut.service.js